(() => {
  const DEPOSIT_VARIANT_ID = 51308368068925;
  const DEFAULT_DEPOSIT_CHOICE =
    'Ja – refunderbart pantedepositum (+200 kr/dyse – refunderes ved retur med vedlagt returetikett)';
  const PRE_DELIVERED_CHOICE =
    'Leverer gammel dyse ved henting i Bergen / sendt inn på forhånd (0 kr)';
  let depositSyncPromise = null;

  function isPreDeliveredChoice(val) {
    if (!val) return false;
    const s = String(val).toLowerCase();
    return s.includes('forhånd');
  }

  function inferPackSize(item) {
    const raw = item?.properties?._dyser_i_pakke;
    const explicit = parseInt(raw || 0, 10);
    if (Number.isFinite(explicit) && explicit > 0) return explicit;
    if (item?.handle === 'pantedepositum') return 0;

    const pt = String(item?.product_type || '').toLowerCase();
    const tt = String(item?.product_title || item?.title || '').toLowerCase();
    const nonInj =
      pt.includes('injektorspiss') ||
      pt.includes('monteringstilbehør') ||
      pt.includes('høytrykkspumpe') ||
      pt.includes('sensor') ||
      pt.includes('trykkregulat') ||
      tt.includes('injektorspiss') ||
      tt.includes('pakningssett') ||
      tt.includes('kobberpakning') ||
      tt.includes('kopperpakning') ||
      tt.includes('tetningsskive') ||
      tt.includes('seal kit') ||
      tt.includes('strekkbolt') ||
      tt.includes('o-ring') ||
      tt.includes('o ringer') ||
      tt.includes('høytrykkspumpe') ||
      tt.includes('testing av');
    if (!nonInj && (pt.includes('dyse') || tt.includes('dyse') || tt.includes('injektor') || tt.includes('dcri'))) {
      if (tt.includes('6 pakning') || tt.includes('6-pakning') || tt.includes('6 stk') || tt.includes('6stk')) return 6;
      if (tt.includes('5 pakning') || tt.includes('5-pakning') || tt.includes('5 stk') || tt.includes('5stk')) return 5;
      if (tt.includes('4 pakning') || tt.includes('4-pakning') || tt.includes('4 stk') || tt.includes('4stk')) return 4;
      if (tt.includes('2 stk') || tt.includes('2stk')) return 2;
      return 1;
    }
    return 0;
  }

  function calculatePantDeposit(cart, overrideChoice) {
    let requiredDepositQty = 0;
    let currentDepositQty = 0;

    const box = document.getElementById('pant-choice');
    const checkedRadio = box ? box.querySelector('input[name="pant_return_choice"]:checked') : null;
    const activeCartChoice =
      overrideChoice || (checkedRadio ? checkedRadio.value : cart?.attributes?.['Pant retur'] || '');
    const cartExempt = isPreDeliveredChoice(activeCartChoice);

    for (const item of cart?.items || []) {
      if (Number(item.variant_id) === DEPOSIT_VARIANT_ID) {
        currentDepositQty += Number(item.quantity || 0);
      } else {
        const packSize = inferPackSize(item);
        if (packSize > 0 && !cartExempt) {
          requiredDepositQty += Number(item.quantity || 0) * packSize;
        }
      }
    }

    return {
      depositVariantId: DEPOSIT_VARIANT_ID,
      requiredDepositQty,
      currentDepositQty,
    };
  }

  window.calculatePantDeposit = calculatePantDeposit;

  async function fetchCart() {
    const root = window.Shopify?.routes?.root || '/';
    const res = await fetch(`${root}cart.js`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error('Kunne ikke hente cart.js');
    return await res.json();
  }

  function renderUpdatedSections(parsedState) {
    if (!parsedState?.sections) return;

    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems && parsedState.sections['main-cart-items']) {
      const doc = new DOMParser().parseFromString(parsedState.sections['main-cart-items'], 'text/html');
      const newContents = doc.querySelector('.js-contents');
      const currentContents = mainCartItems.querySelector('.js-contents');
      if (newContents && currentContents) {
        currentContents.innerHTML = newContents.innerHTML;
      }
      const cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl) {
        cartItemsEl.classList.toggle('is-empty', parsedState.item_count === 0);
      }
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    const footerSecKey = mainCartFooter?.dataset?.id || 'main-cart-footer';
    const footerHtml = parsedState.sections[footerSecKey] || parsedState.sections['main-cart-footer'];
    if (mainCartFooter && footerHtml) {
      const doc = new DOMParser().parseFromString(footerHtml, 'text/html');
      const newContents = doc.querySelector('.js-contents');
      const currentContents = mainCartFooter.querySelector('.js-contents');
      if (newContents && currentContents) {
        currentContents.innerHTML = newContents.innerHTML;
      }
      mainCartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    }
    const panteInfoBoks = document.querySelector('.pante-info-boks');
    if (panteInfoBoks && Array.isArray(parsedState.items)) {
      const hasPant = parsedState.items.some((i) => Number(i.variant_id) === DEPOSIT_VARIANT_ID && Number(i.quantity) > 0);
      panteInfoBoks.style.display = hasPant ? 'flex' : 'none';
    }

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && parsedState.sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
      const inner = doc.querySelector('.shopify-section');
      if (inner) {
        cartIconBubble.innerHTML = inner.innerHTML;
      }
    }

    const pantWrapper = document.getElementById('pant-choice-wrapper');
    if (pantWrapper) {
      pantWrapper.classList.toggle('hidden', parsedState.item_count === 0);
    }
  }

  async function syncPantDeposit(options = {}) {
    if (depositSyncPromise) {
      try {
        await depositSyncPromise;
      } catch (_) {}
    }

    const run = async () => {
      const root = window.Shopify?.routes?.root || '/';
      const cart = options.cart || (await fetchCart());

      const box = document.getElementById('pant-choice');
      const checkedRadio = box ? box.querySelector('input[name="pant_return_choice"]:checked') : null;
      const prodSelect = Array.isArray(options.sections) ? document.querySelector('.ds-pant-select') : null;
      const prodMappedChoice = prodSelect
        ? isPreDeliveredChoice(prodSelect.value)
          ? PRE_DELIVERED_CHOICE
          : DEFAULT_DEPOSIT_CHOICE
        : null;

      const chosenValue =
        options.pantReturnChoice ||
        prodMappedChoice ||
        (checkedRadio ? checkedRadio.value : null) ||
        cart?.attributes?.['Pant retur'] ||
        DEFAULT_DEPOSIT_CHOICE;

      const { requiredDepositQty, currentDepositQty } = calculatePantDeposit(cart, chosenValue);
      const currentAttr = cart?.attributes?.['Pant retur'] || '';

      const needsDepositUpdate = currentDepositQty !== requiredDepositQty;
      const needsAttrUpdate = Boolean(chosenValue && currentAttr !== chosenValue);

      if (!needsDepositUpdate && !needsAttrUpdate) {
        return cart;
      }

      const payload = {};
      if (needsDepositUpdate) {
        payload.updates = { [DEPOSIT_VARIANT_ID]: requiredDepositQty };
      }
      if (needsAttrUpdate) {
        payload.attributes = {
          ...(cart.attributes || {}),
          'Pant retur': chosenValue,
        };
        payload.note = 'Panteordning: ' + chosenValue;
      }

      const defaultSections = [];
      if (document.getElementById('main-cart-items')) defaultSections.push('main-cart-items');
      if (document.getElementById('main-cart-footer')) defaultSections.push(document.getElementById('main-cart-footer').dataset.id || 'main-cart-footer');
      if (document.getElementById('cart-icon-bubble')) defaultSections.push('cart-icon-bubble');
      if (document.getElementById('cart-live-region-text')) defaultSections.push('cart-live-region-text');

      const sectionsToRequest = Array.isArray(options.sections)
        ? Array.from(new Set([...options.sections, ...defaultSections]))
        : defaultSections;

      if (sectionsToRequest.length > 0) {
        payload.sections = sectionsToRequest;
        payload.sections_url = window.location.pathname;
      }

      const res = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        console.error('Pant synk feilet:', await res.text());
        return cart;
      }

      const updatedState = await res.json();
      if ((needsDepositUpdate || needsAttrUpdate) && options.renderDOM !== false) {
        renderUpdatedSections(updatedState);
      }
      return updatedState;
    };

    depositSyncPromise = run();
    try {
      return await depositSyncPromise;
    } finally {
      depositSyncPromise = null;
    }
  }

  window.syncPantDeposit = syncPantDeposit;

  document.addEventListener('DOMContentLoaded', () => {
    syncPantDeposit({ renderDOM: true }).catch((err) => console.error(err));
  });

  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!el || el.name !== 'pant_return_choice') return;
    syncPantDeposit({ pantReturnChoice: el.value, renderDOM: true }).catch((err) => console.error(err));
  });
})();
